module.exports = __webpack_public_path__ + "img/3-3.5d6c321c.png";